import React from 'react';
import { AutoBetPopUp } from './autoBetPopUp';
import { FavoriteBetsPopUp } from './favoriteBetsPopUp';
import { StatisticsPopup } from './statisticsPopup';
import { isMobile } from '@pascal/pascal-core';


export const OptionBetPopUps = ({ isShowAutoPlay, isShowBetActionModal, setIsShowBetActionModal }) => {

  const handleShowBetActionModal = (type) => {
    if (type === isShowBetActionModal) {
      setIsShowBetActionModal(false);
    } else {
      setIsShowBetActionModal(type);
    }
  };

  return (
    <>
      <StatisticsPopup
        isMobile={isMobile}
        handleShowBetActionModal={handleShowBetActionModal}
        isShowBetActionModal={isShowBetActionModal}
      />
      <FavoriteBetsPopUp
        isMobile={isMobile}
        handleShowBetActionModal={handleShowBetActionModal}
        isShowBetActionModal={isShowBetActionModal}
      />
      {isShowAutoPlay && (
        <AutoBetPopUp
          isMobile={isMobile}
          handleShowBetActionModal={handleShowBetActionModal}
          isShowBetActionModal={isShowBetActionModal}
        />
      )}
    </>
  );
};